'use client';

import { WistiaPlayer } from '@wistia/wistia-player-react';
import { JSX, useState } from 'react';

import { cn } from '@videoblocks/design-system';

/**
 * The Wistia player, revealed only once it starts playing.
 *
 * Until then the poster underneath shows through, which is what the visitor keeps if the script is
 * blocked or autoplay is refused.
 */
export function WistiaEmbedPlayer({ mediaId, posterUrl }: { mediaId: string; posterUrl?: string }): JSX.Element {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <div
            aria-hidden
            className={cn(
                'absolute inset-0 h-full w-full transition-opacity duration-500',
                isPlaying ? 'opacity-100' : 'opacity-0',
            )}
        >
            <WistiaPlayer
                mediaId={mediaId}
                poster={posterUrl}
                // Wistia's own placeholder: a low-resolution still stretched across the box.
                swatch={false}
                autoplay
                muted
                silentAutoplay="allow"
                endVideoBehavior="loop"
                fitStrategy="cover"
                controlsVisibleOnLoad={false}
                bigPlayButton={false}
                playBarControl={false}
                settingsControl={false}
                volumeControl={false}
                fullscreenControl={false}
                onPlay={() => setIsPlaying(true)}
                className="h-full w-full"
            />
        </div>
    );
}
